import { render } from "./AddOtherFile.vue?vue&type=template&id=1dbf3445&scoped=true"
import script from "./AddOtherFile.vue?vue&type=script&lang=js"
export * from "./AddOtherFile.vue?vue&type=script&lang=js"

import "./AddOtherFile.vue?vue&type=style&index=0&id=1dbf3445&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbf3445"]])

export default __exports__